@if(templates.length > 1) {
	<select aria-label="Template" [id]="templateSelectorId" class="form-select ms-2" [formControl]="templateControl"
		(change)="changeTemplate()" data-cy="TemplateSelector">
		@if(includeSelect) {
			<option [value]="-1">Select Template</option>
		}
		@for(t of templates; track t.templateID) {
			<option [value]="t.templateID" [attr.data-cy]="t.templateName">
				{{labelFn(t)}}
			</option>
		}
	</select>
}